import React from 'react'
import './MobSolution.css'
import gif1 from './../../../Assets/video1.gif'
import gif2 from './../../../Assets/video2.gif'


function MobSolution() {
    return (
        <div id='Mobsolution_lan'>
                <img src={gif1} className='img_solution1'/>
                <img src={gif2} className='img_solution2'/>
        </div>
    )
}

export default MobSolution
